let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5XL35")).then(() => parcelRequire('81XdU'));